RivalIQ.apps.CompanyProfile.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const SocialPosts = RivalIQ.apps.SocialPosts;

    const SocialPostDetails = Dashboard.views.DetailsLayout.mixin({
        mixins: {
            SocialPostsLayout: SocialPosts.curations._socialPostsLayoutMixin,
            SearchableLayout: RivalIQ.apps.Dashboard.mixins.SearchableLayout
        },
        className: 'flex-toolbar-layout details',
        template: '#dashboardSocialPostsDetailsLayoutTemplate',
        dashboardModelEvents: {
            'change:searchTerm': 'reload'
        },
        // NOTE the base class does work on `onBeforeShow`, which fires outside
        // of the loading lifecycle, so we need to override it and call it
        // manually in `onRenderLoaded` (all of this is to get the correct
        // error handling behavior for search terms)
        onBeforeShow: _.noop,
        onRenderLoaded: function () {
            const me = this;

            me._nonBlockingLoad
                .then(() => {

                    Dashboard.views.DetailsLayout.prototype.onBeforeShow.apply(me, arguments);
                });
        },
        getBodyView: function () {
            const me = this;
            if (!me.metric) {
                return me.getErrorView(me.getMessageForError(me.errorName));
            }
            return Dashboard.views.DetailsLayout.prototype.getBodyView.apply(me, arguments);
        },
        getErrorView: function (message) {
            const me = this;
            const View = me.getSearchableErrorView();
            return View.extend({
                model: new Backbone.Model({
                    message: message
                })
            });
        },
        showLeftToolbarActions: function () {
            const me = this;

            me.leftActions.show(new SocialPosts.views.Search({
                dashboardModel: me.dashboardModel.curation,
                companyData: new RivalIQ.collections.CompanyData(me.dashboardModel.company)
            }), {
                preventDestroy: true
            });
        }
    });

    curations.Posts = SocialPosts.curations.SocialPosts.mixin({
        mixins: {
            CompanySwitchable: Dashboard.mixins.CompanySwitchable,
            SingleWidget: Dashboard.mixins.SingleWidget
        },

        beforeFilters: [
            curations.filters.loadCompanies,
            SocialPosts.curations.filters.loadCompanyData,
            SocialPosts.curations.filters.loadPostTags
        ],

        companySets: false,
        page: RivalIQ.configuration.menus.getPageByName('Company'),
        validWidgetOptions: SocialPosts.utils.validWidgetOptions.concat('companyId'),
        validCurationOptions: SocialPosts.utils.validCurationOptions.concat('companyId'),
        propsToSerializeForExport: SocialPosts.utils.widgetExportProps.concat('metrics', 'companyId', 'format'),
        widgetsView: RivalIQ.apps.Dashboard.views.Widgets.extend({
            wrapperView: SocialPostDetails
        }),

        getBasePath: function (overrides) {
            const me = this;

            // We're only showing a single widget in this curation, so grab the props of it;
            // that way, when the user is switching between channels and companies, it'll stick.
            const widgetProps = me.widgets?.at(0)?.getProps() || me.getProps();

            let orderBy = widgetProps.orderBy;
            let sortOrder = widgetProps.sortOrder;
            // NOTE if we are changing the channel then we need to also reset
            // the `orderBy` prop (as it may not be valid for the new channel
            if (overrides.channel !== widgetProps.channel) {
                orderBy = undefined;
                sortOrder = undefined;
            }

            const props = _.defaults(_.omit(overrides, 'instanceId'), {
                companyId: me.getProp('companyIds'),
                layout: widgetProps.layout,
                orderBy: orderBy,
                sortOrder: sortOrder
            });

            return me.router.resolveCurationRoute(me.id, props);
        },

        getExportTitle: function () {
            const me = this;
            return `${RivalIQ.props.companyName(me.getProps())} Posts`;
        },

        getExportSubtitle: function () {
            const me = this;

            const channel = RivalIQ.props.getChannel(me.getProps());
            const subtitleParts = [
                channel.get('name')
            ];

            // TODO: need to see all the filters applied
            const searchTerm = me.getProp('searchTerm');
            if (searchTerm) {
                subtitleParts.push((`Query: "${_.escape(searchTerm)}"`));
            }

            const type = me.getProp('type');
            if (type) {
                const typeName = _.get(RivalIQ.enums.postTypes, [type, 'format'], type);
                subtitleParts.push(`Post Type: ${_.escape(typeName)}`);
            }

            const periodStart = me.getProp('timePeriod').mainPeriodStart;
            const companiesWithIncompleteData = SocialPosts.utils.findCompaniesWithIncompleteData(
                new RivalIQ.collections.CompanyData(me.company),
                channel.id,
                periodStart);
            if (!_.isEmpty(companiesWithIncompleteData)) {
                subtitleParts.push('(Incomplete data)');
            }

            return _.map(subtitleParts, function (str) {
                return str.replace(' ', '&nbsp');
            }).join(', ');
        },

        processProps: function (props) {
            // NOTE it is possible that `props.channel` will have a value for
            // Cross Channel, when it shouldn't, and if we don't alias it to
            // `undefined` then the curation will fail to load (see #19899)
            const channel = RivalIQ.data.channels.get(props.channel);
            if (channel.isCrossChannel()) {
                props.channel = undefined;
            }

            if (props.companyId) {
                props.companyIds = props.companyId;
            }
            delete props.companyId;

            return props;
        }
    });

});
